let spriteLoad: Promise<void> | undefined;

/** Inject the host's icon sprite once; importing this module has no DOM effects. */
export function loadIconSprite(url: string): Promise<void> {
  spriteLoad ??= fetch(url)
    .then(async (response) => {
      if (!response.ok)
        throw new Error(`Unable to load icon sprite: ${response.status}`);
      const doc = new DOMParser().parseFromString(
        await response.text(),
        "image/svg+xml",
      );
      const element = doc.documentElement;
      if (element.localName !== "svg") throw new Error("Invalid icon sprite");
      element.setAttribute("aria-hidden", "true");
      element.style.position = "absolute";
      element.style.width = "0";
      element.style.height = "0";
      element.style.overflow = "hidden";
      document.body.prepend(element);
    })
    .catch((error: unknown) => {
      spriteLoad = undefined;
      throw error;
    });
  return spriteLoad;
}
